module.exports = __webpack_public_path__ + "static/media/image-2.45308157.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Home/image-2.jpg
// module id = 151
// module chunks = 0